import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { LibLongPressModule } from '../long-press/long-press.module';
import { IncrementInputComponent } from './increment-input.component';

@NgModule({
    imports: [CommonModule, MatFormFieldModule, MatIconModule, MatButtonModule, FormsModule, MatInputModule, MatTooltipModule, LibLongPressModule],
    declarations: [IncrementInputComponent],
    exports: [IncrementInputComponent],
})
export class LibIncrementInputModule {}
